import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="bg-gradient-to-r from-cta to-rose-400 py-20 px-4 text-center" data-id="element-74">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto" data-id="element-75">
        <h2 className="text-3xl md:text-5xl text-white font-display font-extrabold tracking-headline mb-8 leading-tight" data-id="element-76">
          El momento de cambiar tu realidad financiera es ahora.
        </h2>

        <motion.a href="https://www.vitarutinas.com/cart/50347583471862:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="shimmer-cta inline-block w-full sm:w-auto bg-dark hover:bg-slate-800 text-white font-bold rounded-full px-10 py-6 text-xl shadow-2xl text-center relative overflow-hidden" animate={{
        scale: [1, 1.04, 1]
      }} transition={{
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} whileHover={{
        scale: 1.07
      }} whileTap={{
        scale: 0.97
      }} data-id="element-77">
          [ SÍ, QUIERO MI SISTEMA MAMÁ IA POR $6.36 ]
        </motion.a>

        <p className="text-white/90 mt-6 font-medium text-sm md:text-base" data-id="element-78">
          Acceso inmediato • Descarga digital • Empieza hoy mismo
        </p>
      </motion.div>
    </section>;
}